import { Utils } from '../../core/services/utils.service';

export class Equipment {
	id: number;
	name: string;
	points: any[] = [];
	type: any = 'points';
	color: string = '#e0e0e0';
	image: string = '';
	width: number;
	height: number;
	updated_at: string;
	code: string;
	producer: string;

	constructor(params: any) {
		const { id, name, code, image, updated_at, type, producer } = params;

		Object.assign(this, Utils.validate({ id, name, code, image, type, producer }));

		this.updated_at = updated_at;

		const shapes = params.linear_conf.bases.map(s => s.shapes[0]);

		this.width = Utils.sum(shapes.map(shape => {
			switch (shape.type) {
				case 'rectangle':
					return shape.width;

				case 'trapeze':
					return Math.max(shape.frontWidth, shape.backWidth);
			}
		}));

		for (let shape of shapes) {
			switch (shape.type) {
				case 'rectangle': {
					this.points.push(
						{
							begin: {
								x: shape.begin.x,
								y: shape.begin.y
							},
							points: [
								{ x: shape.width, y: 0 },
								{ x: 0, y: 0 },
								{ x: 0, y: shape.depth },
								{ x: shape.width, y: shape.depth }
							],
							leftSideRadius: shape.leftSideRadius ?? 0,
							rightSideRadius: shape.rightSideRadius ?? 0
						}
					);
					this.height = shape.depth;
					break;
				}
				case 'trapeze': {
					if (shape.frontWidth >= shape.backWidth) {
						this.points.push(
							{
								begin: {
									x: shape.begin.x,
									y: shape.begin.y
								},
								points: [
									{ x: (shape.frontWidth + shape.backWidth) / 2, y: 0 },
									{ x: (shape.frontWidth - shape.backWidth) / 2, y: 0 },
									{ x: 0, y: shape.depth },
									{ x: shape.frontWidth, y: shape.depth }
								],
								leftSideRadius: shape.leftSideRadius ?? 0,
								rightSideRadius: shape.rightSideRadius ?? 0
							}
						);
					} else {
						this.points.push({
							begin: {
								x: shape.begin.x,
								y: shape.begin.y
							},
							points: [
								{ x: shape.backWidth, y: 0 },
								{ x: 0, y: 0 },
								{ x: (shape.backWidth - shape.frontWidth) / 2, y: shape.depth },
								{ x: (shape.backWidth + shape.frontWidth) / 2, y: shape.depth }
							],
							leftSideRadius: shape.leftSideRadius ?? 0,
							rightSideRadius: shape.rightSideRadius ?? 0
						});
					}
                    this.height = shape.depth;
                    break;
				}
			}
		}
	}
}